module.exports = __webpack_public_path__ + "static/img/jfld.7c012cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/jfld.png
// module id = XEya
// module chunks = 44